import { formulaireContactB2cMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [formulaireContactB2cMock];

export const contactMock: SlugPage = {
  ...pageBase({
    title: 'Contact',
    type: 'contact',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
